var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('MapCards',{attrs:{"cards":_vm.maps,"filterOnlyMyMaps":_vm.filterOnlyMyMaps,"filterOnlyFavorites":_vm.filterOnlyFavorites,"hasLobby":_vm.hasLobby},on:{"toggleFavorite":_vm.toggleFavorite}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }